"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact2 = _interopRequireDefault(require("downshift/preact"));

var _Fetch = _interopRequireDefault(require("./Fetch"));

var _PillContainer = _interopRequireDefault(require("../pills/PillContainer"));

var _Pill = _interopRequireDefault(require("../pills/Pill"));

var _ItemList = _interopRequireDefault(require("./ItemList"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Selector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Selector, _Component);

  var _super = _createSuper(Selector);

  function Selector() {
    var _this$props$initialIt, _this$props$initialIt2;

    var _this;

    (0, _classCallCheck2.default)(this, Selector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "input", (0, _preact.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedItems: (_this$props$initialIt = (_this$props$initialIt2 = _this.props.initialItems) === null || _this$props$initialIt2 === void 0 ? void 0 : _this$props$initialIt2.map(function (initialItem) {
        initialItem.isValid = true;
        return initialItem;
      })) !== null && _this$props$initialIt !== void 0 ? _this$props$initialIt : []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (selectedItem, downshift) {
      var item = Object.assign(selectedItem, {
        isValid: true
      });

      _this.addItem(item, downshift.reset);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addItem", function (item, reset) {
      _this.setState(function (_ref) {
        var selectedItems = _ref.selectedItems;
        return {
          selectedItems: [].concat((0, _toConsumableArray2.default)(selectedItems), [item])
        };
      }, function () {
        reset();

        var selectedItems = _this.state.selectedItems.filter(function (item) {
          return item.isValid;
        });

        _this.props.onChange(selectedItems);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onRemoveItem", function (item) {
      _this.setState(function (_ref2) {
        var selectedItems = _ref2.selectedItems;
        return {
          selectedItems: selectedItems.filter(function (c) {
            return c !== item;
          })
        };
      }, function () {
        _this.input.current.focus();

        var selectedItems = _this.state.selectedItems.filter(function (item) {
          return item.isValid;
        });

        _this.props.onChange(selectedItems);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "validateItem", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(value, reset) {
        var onValidate, itemToStringKey, _item, _item3, _item2, _item5, _item4;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                onValidate = _this.props.onValidate;
                itemToStringKey = _this.props.config.itemToStringKey;

                if (!onValidate) {
                  _context.next = 9;
                  break;
                }

                _context.next = 5;
                return onValidate(value);

              case 5:
                _item = _context.sent;

                if (_item) {
                  _item = Object.assign(_item, {
                    isValid: true
                  });

                  _this.addItem(_item, reset);
                } else {
                  _item2 = (_item3 = {}, (0, _defineProperty2.default)(_item3, itemToStringKey, value), (0, _defineProperty2.default)(_item3, "isValid", false), _item3);

                  _this.addItem(_item2, reset);
                }

                _context.next = 11;
                break;

              case 9:
                _item4 = (_item5 = {}, (0, _defineProperty2.default)(_item5, itemToStringKey, value), (0, _defineProperty2.default)(_item5, "isValid", true), _item5);

                _this.addItem(_item4, reset);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPaste", function (_ref4) {
      var event = _ref4.event,
          reset = _ref4.reset,
          omitItems = _ref4.omitItems;
      var delimiter = _this.props.config.delimiter;
      var clipboardData = event.clipboardData;
      if (!clipboardData) return;
      var value = clipboardData.getData('Text');
      var isDelimeterSeparatedList = value.search(delimiter) !== -1;

      if (isDelimeterSeparatedList) {
        var values = value.split(delimiter).filter(function (x) {
          return x.trim();
        }).map(function (y) {
          return y.trim();
        });
        values = (0, _toConsumableArray2.default)(new Set(values)); // Remove duplicate values in array

        values = values.filter(function (item) {
          return !omitItems.includes(item);
        }); // Filter out selected already selected items

        values.forEach(function (value) {
          _this.validateItem(value, reset);
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeyDown", function (_ref5) {
      var event = _ref5.event,
          selectHighlightedItem = _ref5.selectHighlightedItem,
          highlightedIndex = _ref5.highlightedIndex,
          isOpen = _ref5.isOpen,
          reset = _ref5.reset;
      var selectedItems = _this.state.selectedItems;
      var itemToStringKey = _this.props.config.itemToStringKey;
      var _this$props$config$ke = _this.props.config.keys,
          insert = _this$props$config$ke.insert,
          remove = _this$props$config$ke.remove;
      var _ref6 = event.target,
          value = _ref6.value;
      var key = event.key;

      if (remove.includes(key)) {
        if (value) return;
        var _item6 = selectedItems[selectedItems.length - 1];

        _this.onRemoveItem(_item6);

        return;
      }

      if (insert.includes(key)) {
        if (highlightedIndex === null) {
          if (!value) return;

          var _selectedItems = _this.state.selectedItems.map(function (item) {
            return item[itemToStringKey];
          });

          if (_selectedItems.includes(value)) return;

          _this.validateItem(value, reset);

          return;
        }

        if (isOpen) {
          event.preventDefault();
          selectHighlightedItem();
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "itemToString", function (item) {
      var itemToStringKey = _this.props.config.itemToStringKey;
      return item ? item[itemToStringKey] : '';
    });
    return _this;
  }

  (0, _createClass2.default)(Selector, [{
    key: "filterItems",
    value: // eslint-disable-next-line class-methods-use-this
    function filterItems(items, selectedItems, omitItemsKey) {
      var omitItems = selectedItems.map(function (item) {
        return item[omitItemsKey];
      });
      return items.filter(function (item) {
        return !omitItems.includes(item[omitItemsKey]);
      }).slice(0, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _props$config$dynamic,
          _this2 = this;

      var props = this.props;
      var state = this.state;
      var dynamicConfig = (_props$config$dynamic = props.config.dynamic) !== null && _props$config$dynamic !== void 0 ? _props$config$dynamic : null;
      var _props$config = props.config,
          itemToStringKey = _props$config.itemToStringKey,
          itemElement = _props$config.itemElement;
      var selectedItems = state.selectedItems;
      return (0, _preact.h)(_preact2.default, {
        selectedItem: null,
        onChange: this.handleChange,
        itemToString: this.itemToString
      }, function (_ref7) {
        var getInputProps = _ref7.getInputProps,
            getItemProps = _ref7.getItemProps,
            getMenuProps = _ref7.getMenuProps,
            isOpen = _ref7.isOpen,
            highlightedIndex = _ref7.highlightedIndex,
            selectHighlightedItem = _ref7.selectHighlightedItem,
            setHighlightedIndex = _ref7.setHighlightedIndex,
            reset = _ref7.reset,
            inputValue = _ref7.inputValue,
            clearItems = _ref7.clearItems,
            setItemCount = _ref7.setItemCount;
        return (0, _preact.h)("div", {
          className: "selector ".concat(props.error ? 'invalid' : '')
        }, (0, _preact.h)(_PillContainer.default, null, selectedItems.map(function (item, idx) {
          return (0, _preact.h)(_Pill.default, {
            key: idx,
            isValid: _this2.props.onValidate ? item.isValid : true
          }, itemElement(item), (0, _preact.h)(_Close.default, {
            className: "qa-dismiss-filter-pill",
            width: 16,
            height: 16,
            onClick: function onClick() {
              return _this2.onRemoveItem(item);
            }
          }));
        }), (0, _preact.h)("div", {
          className: "selector__input-wrapper"
        }, (0, _preact.h)("input", getInputProps({
          ref: _this2.input,
          placeholder: _this2.props.placeholder,
          onPaste: function onPaste(event) {
            return _this2.onPaste({
              event: event,
              reset: reset,
              omitItems: selectedItems.map(function (item) {
                return item[itemToStringKey];
              })
            });
          },
          onKeyDown: function onKeyDown(event) {
            return _this2.onKeyDown({
              event: event,
              selectHighlightedItem: selectHighlightedItem,
              highlightedIndex: highlightedIndex,
              isOpen: isOpen,
              reset: reset
            });
          }
        })), dynamicConfig && inputValue && Boolean(isOpen) && (0, _preact.h)(_Fetch.default, {
          baseUrl: dynamicConfig.baseUrl,
          searchValue: inputValue,
          onLoaded: function onLoaded(_ref8) {
            var items = _ref8.items;
            clearItems();

            if (items) {
              setHighlightedIndex(items.length ? 0 : null);
              setItemCount(items.length);
            }
          },
          responseKey: dynamicConfig.responseKey,
          customFetch: props.customFetch
        }, function (_ref9) {
          var loading = _ref9.loading,
              items = _ref9.items;
          return (0, _preact.h)(_ItemList.default, {
            loading: loading,
            items: _this2.filterItems(items, selectedItems, dynamicConfig.omitItemsKey),
            getMenuProps: getMenuProps,
            getItemProps: getItemProps,
            highlightedIndex: highlightedIndex
          }, function (item) {
            return dynamicConfig.dynamicItemElement(item);
          });
        }))));
      });
    }
  }]);
  return Selector;
}(_preact.Component);

var _default = Selector;
exports.default = _default;